module.exports = __webpack_public_path__ + "assets/img/kv-5e3e8fe6.jpg";